// src/ScrollManager.jsx
import { useLocation, useNavigationType } from "react-router-dom";
import { useLayoutEffect } from "react";

const ScrollManager = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    // Tell browser we handle scroll manually
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const key = location.key || location.pathname;

    const saved = sessionStorage.getItem(`scroll-${key}`);
    const savedY = saved ? parseInt(saved, 10) : 0;

    let rafId1;
    let rafId2;

    if (navigationType === "POP" && saved) {
      // 🔁 Try twice in rAF to wait for layout/render
      rafId1 = requestAnimationFrame(() => {
        rafId2 = requestAnimationFrame(() => {
          window.scrollTo(0, savedY);
        });
      });
    } else {
      // Normal navigation: scroll to top
      window.scrollTo(0, 0);
    }

    const handleScroll = () => {
      sessionStorage.setItem(`scroll-${key}`, window.scrollY.toString());
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      cancelAnimationFrame(rafId1);
      cancelAnimationFrame(rafId2);
    };
  }, [location.key, location.pathname, navigationType]);

  return null;
};

export default ScrollManager;
